<template>
    <div class="animated fadeIn h-100 m-4">
    <!--CCard>
      <CCardBody>
        <CRow>
          <TimeLine></TimeLine>
        </CRow>
      </CCardBody>
    </CCard-->
    <CCard>
      <CCardHeader><strong>{{this.deviceInfo.name}}</strong></CCardHeader>
      <CCardBody>
        <CRow>
            <CCol sm="2" style="color: #39f; text-align:center; font-size: 22px; line-height:35px"><b>{{this.device}}</b></CCol>
            <CCol sm="2"><span class="float-left pr-2 pt-1">From: </span><date-picker ref="dateFrom" v-model="dateFrom" :config="options" style="width: initial;"></date-picker></CCol>
            <CCol sm="2"><span class="float-left pr-2 pt-1">To: </span><date-picker v-model="dateTo" :config="options" style="width: initial;"></date-picker></CCol>
            <CCol sm="2"><CButton color="info" shape="square" class="pl-5 pr-5" @click="filterData()">Filter</CButton></CCol>
            <CCol sm="2"></CCol>
            <CCol sm="2" class="pt-2"><CSwitch class="mx-1" color="info" @change.native="updateMap()" checked variant="opposite" shape="pill" size="sm" v-bind:checked.sync="hideLowAcc"/> <span class="align-top">Hide low accuracy locations</span></CCol>
        </CRow>
        <CRow>
          <CCol sm="12">
            Timeline:
            <vue-slider v-model="currentMarker" v-bind="sliderOptions" :tooltip-formatter="timestampFormater"/>
          </CCol>
        </CRow>
        <CRow>
          <gmap-map :center="center" :zoom="zoom" ref="mapa" map-type-id="roadmap" class="m-3" style="width: 100%; height: 500px">
            <gmap-cluster :grid-size="gridSize" v-if="clustering" v-on:click="clustering=false">
                <gmap-custom-marker v-if="view=='asset' || view=='world'" :key="index" v-for="(m, index) in markers" :marker="m.position" :clickable="true" @click.native="openDevice(m)" :title="m.devicename" style="margin-top: 16px;"><div class="mapMarker"><i :class="markerClass(m.event)" /></div></gmap-custom-marker>
            </gmap-cluster>

            <gmap-custom-marker v-if="(view=='asset' || view=='world') && clustering==false" :key="index" v-for="(m, index) in markers" :marker="m.position" :clickable="true" @click.native="openDevice(m)" :title="m.devicename" style="margin-top: 16px;"><div class="mapMarker"><i :class="markerClass(m.event)" /></div></gmap-custom-marker>
            <gmap-polyline v-if="view=='asset' && paths.length > 0" v-bind:path.sync="paths" v-bind:options="{ strokeColor:'#00800050'}" v-on:click="InfoWindowShown = true">
              <info-window :opened="InfoWindowShown" @closeclick="InfoWindowShown = false" >
              <h1>Test</h1>
              </info-window>
            </gmap-polyline>
            <gmap-circle  v-for="(m, index) in markers" :center="m.position" :visible="true" :radius="m.radius" :options="{fillColor:'green',fillOpacity:0.1, strokeWeight: 1, strokeOpacity:0.2}" ></gmap-circle>
          </gmap-map>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
        <CCardHeader><strong>Messages</strong></CCardHeader>
      <CCardBody>
        <CRow>
          <CDataTable
              hover="hover"
              striped="striped"
              bordered="bordered"
              small="small"
              fixed="fixed"
              :items="messagesLoaded"
              :fields="fields"
              :items-per-page="5"
              class="m-3 w-100"
              pagination
            >
              <template #time="{item}"><td :class="pathsLoaded[pathsLoaded.length-currentMarker-1].time == item.time ? 'bg-secondary' : ''">{{formatDate(item.time)}}</td></template>
              <template #seqnumber="{item}"><td :class="pathsLoaded[pathsLoaded.length-currentMarker-1].time == item.time ? 'bg-secondary' : ''">{{item.seqnumber}}</td></template>
              <template #name="{item}"><td :class="pathsLoaded[pathsLoaded.length-currentMarker-1].time == item.time ? 'bg-secondary' : ''"><CLink @click="editZone(item)">{{item.name}}</CLink></td></template>
              <template #zones="{item}"><td :class="pathsLoaded[pathsLoaded.length-currentMarker-1].time == item.time ? 'bg-secondary' : ''"><CBadge v-if="m.name !== null" v-for="(m, index) in getZones(item.zones)" :color="m.id == '00000000-0000-0000-0000-000000000000' ? 'warning' : 'info'" class="mr-1">{{m.name}}</CBadge></td></template>
              <template #source="{item}"><td :class="pathsLoaded[pathsLoaded.length-currentMarker-1].time == item.time ? 'bg-secondary' : ''"><CBadge :color="sourceColor(item.source)" class="mr-1">{{sourceType(item.source)}}</CBadge></td></template>
              <template #radius="{item}"><td :class="pathsLoaded[pathsLoaded.length-currentMarker-1].time == item.time ? 'bg-secondary' : ''">{{item.radius}}</td></template>
              <template #event="{item}"><td :class="pathsLoaded[pathsLoaded.length-currentMarker-1].time == item.time ? 'bg-secondary' : ''">{{item.event}}</td></template>
              <template #show_details="{item, index}">
                <td :class="'py-2 ' + (pathsLoaded[pathsLoaded.length-currentMarker-1].time == item.time ? 'bg-secondary' : '')">
                  <CButton
                    color="primary"
                    variant="outline"
                    square
                    size="sm"
                    @click="toggleDetails(item, index)"
                  >
                    {{Boolean(item._toggled) ? 'Hide' : 'Show'}}
                  </CButton>
                </td>
              </template>
              <template #lqi="{item}"><td :class="pathsLoaded[pathsLoaded.length-currentMarker-1].time == item.time ? 'bg-secondary' : ''"><img :src="'/img/'+item.lqi+'.png'" :title=item.lqi></td></template>
              <template #details="{item}">
                <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">
                  <CCardBody>
                    <CRow>
                      <CCol sm="3">
                        <p v-if="item.mac1 !== null" class="text-muted">MAC1: {{item.mac1}}</p>
                        <p v-if="item.mac2 !== null" class="text-muted">MAC2: {{item.mac2}}</p>
                        <p v-if="item.mac3 !== null" class="text-muted">MAC3: {{item.mac3}}</p>

                        <!--CButton size="sm" color="info" class="" :disabled="true">
                          Set custom location
                        </CButton-->
                        <!--CButton v-if="item.source == 10" size="sm" color="danger" class="ml-1"  :disabled="true">
                          Delete
                        </CButton-->
                      </CCol>
                      <CCol sm="3">
                        <p v-if="item.temperature !== null"class="text-muted">Temperature: {{item.temperature}}</p>
                        <p v-if="item.voltage !== null && deviceInfo.type != 'rita_pir'" class="text-muted">Voltage: {{item.voltage}}</p>
                        <p v-if="item.voltage !== null && deviceInfo.type == 'rita_pir'" class="text-muted">Battery: {{item.voltage}}%</p>
                      </CCol>
                    </CRow>
                  </CCardBody>
                </CCollapse>
              </template>
            </CDataTable>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
      <CCardBody>
      <CTabs>
        <CTab v-if="temperaturecollection.datasets[0].data.length > 0" title="Temperature">
          <LineChart ref="tempChart" :chart-data="temperaturecollection" :options="tempChartOptions" :height="100"></LineChart>
        </CTab>
        <CTab v-if="batterycollection.datasets[0].data.length > 0" title="Battery">
           <LineChart ref="battChart" :chart-data="batterycollection" :options="tempChartOptions" :height="100"></LineChart>
        </CTab>
        <CTab v-if="showUtilization" title="Utilization">
          <LineChart ref="utilChart" :chart-data="utilizationcollection" :options="utilChartOptions" :height="100"></LineChart>
        </CTab>
      </CTabs>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import Vue from 'vue'
import VueSlider from 'vue-slider-component'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'vue-slider-component/theme/antd.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import { telemetry } from '@/api'
import LineChart from './charts/LineChart.js'
import TimeLine from '@/components/TimeLine'
import ChartDataLabels from 'chartjs-plugin-datalabels'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD8vswyC9F9G4rpJnpfpgZAwL4J0C-FhO4',
    libraries: 'places'
  }
})

Vue.component('GmapCluster', GmapCluster)

export default {
  name: 'World',
  components: {
      'gmap-custom-marker': GmapCustomMarker,
      VueSlider,
      datePicker,
      TimeLine,
      LineChart,
      ChartDataLabels
  },
  data () {
    return {
      center: {lat: 48, lng: 18},
      zoom: 9,
      device: 'Device',
      deviceName: 'Device',
      markers: [],
      currentMarker: 0,
      paths: [],
      deviceInfo: {},
      pathsLoaded: [],
      messagesLoaded: [],
      temperaturecollection: {
        datasets: [{label: "Temperature", backgroundColor: '#39f', borderColor: '#39f', type: 'line', lineTension: 0, pointRadius: 0, fill:false, data: []}]
      },
      batterycollection: {
        datasets: [{label: "Battery", backgroundColor: '#39f', borderColor: '#39f', type: 'line', lineTension: 0, pointRadius: 0, fill:false, data: []}]
      },
      utilizationcollection: {
        datasets: [{label: "Utilization", backgroundColor: '#39f', borderColor: '#39f', type: 'bar', lineTension: 0, pointRadius: 0, fill:false, data: []}]
      },
      InfoWindowShown: false,
      clustering: true,
      hideLowAcc: true,
      gridSize: 50,
      collapseDuration: 2,
      view: "asset",
      dateFrom: this.startOfDay(this.previous2weeks(new Date())),
      dateTo: this.endOfDay(new Date()),
      options: {
        useCurrent: false,
        locale: 'sk'
      },
      timeFormat: 'MM/DD/YYYY HH:mm:ss a',

      tempChartOptions: {
        scales: {
            xAxes: [{
                type: 'time',
                distribution: 'series',
                time: {
                  unit: 'hours',
                  //stepSize: 3, // I'm using 3 hour intervals here
                  tooltipFormat: 'DD.MM.YYYY - HH:mm:ss',
                  displayFormats: {
                    hours: 'DD.MM - HH:mm'
                  }
                }
            }]
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      },
      utilChartOptions: {
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              var hour = Math.floor(tooltipItem.yLabel)
              var min = Math.floor((tooltipItem.yLabel - Math.floor(tooltipItem.yLabel)) * 60)
              return 'Movement: ' + (hour<10 ? '0':'')+ hour + ':' + (min<10 ? '0':'') + min;
            }
          }
        },
        scales: {
            xAxes: [{
                type: 'time',
                distribution: 'series',
                time: {
                  unit: 'hours',
                  //stepSize: 3, // I'm using 3 hour intervals here
                  tooltipFormat: 'DD.MM.YYYY',
                  displayFormats: {
                    hours: 'DD.MM'
                  }
                }
            }]
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      },
      sliderOptions: {
        min: 0,
        max: 1,
        interval: 1,
      },
      fields: ['time', 'seqnumber' , 'event', 'source', 'radius', 'zones', 'lqi', 'show_details'],
      timestampFormater: v => (this.pathsLoaded.length>0?this.formatDate(this.pathsLoaded[this.pathsLoaded.length - v - 1].time):'')
    }
  },
  computed: {
    path() {
      return this.$router.history.current.fullPath
    },
    showUtilization() {
      return this.deviceInfo !== null && (this.deviceInfo.type == 'simplepack_plus' || this.deviceInfo.type == 'simpleindustry')
    }
  },
  watch: {
    $route(to, from) {
      this.updateMap()
    },
    currentMarker: function(val){
      //console.log(this.pathsLoaded[this.currentMarker].time)

      if(this.markers.length > 0 && this.pathsLoaded.length > val) {
          var selected = this.pathsLoaded[this.pathsLoaded.length - val - 1]
          this.markers[0] = {position: {lat: selected.lat, lng: selected.lng}, seqnumber: selected.seqnumber, event: selected.event, radius: selected.radius}
          this.paths = this.pathsLoaded.slice(this.pathsLoaded.length - val - 1)
          this.$refs.mapa.$mapPromise.then((map) => {
            map.panTo(this.markers[0].position)
          })
      }
    }
  },
  mounted () {
    this.device = this.$router.history.current.fullPath.substring(8,this.$router.history.current.fullPath.length)
    telemetry.deviceInfo(this.device).then(response => {
      this.deviceInfo = response.data[0]
      this.hideLowAcc = this.deviceInfo.type != "seal"
      this.updateMap()
      this.loadUtilization()
    })
  },
  methods: {
    toggleDetails(item, index) {
      item._toggled = item._toggled == true ? false : true
    },
    sourceType(source) {
      switch(source) {
	    case 1: return 'GPS'
        case 2: return 'Atlas'
        case 6:
        case 9: return 'Wifi'
        case 10: return 'Custom'
        case null: return 'None'
        default: return 'Other'
      }
    },
    sourceColor(source) {
      switch(source) {
        case 2: return 'info'
        case 6:
        case 9: return 'primary'
        case 1:
        case 10: return 'success'
        default: return 'secondary'
      }
    },
    getZones(zone) {
      var zones = []
      for(var idx=0; idx<this.$store.state.zones.length; idx++){
        if(zone.includes(this.$store.state.zones[idx].id)) {
          zones.push(this.$store.state.zones[idx])
        }
      }
      if(zone.includes('00000000-0000-0000-0000-000000000000')) {
        zones.push({id: '00000000-0000-0000-0000-000000000000', name: 'Transit'})
      }
      return zones
    },
    previous2weeks(date) {
      date.setDate(date.getDate() - 14)
      return date
    },
    startOfDay(date) {
      date.setHours(0,0,0,0)
      return date
    },
    endOfDay(date) {
      date.setHours(23,59,59,999)
      return date
    },
    markerClass(event, temperature) {
      if(temperature < -5) {
        return "fa fa-snowflake-o"
      }
      switch(event) {
        case "open_full":
        case "open_one_tape":
        case "open_one_button":
        case "cap_released":
        case "disarmed":
        case "heartbeat_open":
              return "fa fa-unlock-alt"
        case "sealed":
        case "sealed_recovered":
        case "armed":
        case "heartbeat_sealed":
              return "fa fa-lock"
        case "stop": return "fa fa-stop"
        case "tilt": return "fa fa-repeat"
        case "tracing": return "fa fa-truck"
        case "start": return "fa fa-play"
        case "heartbeat": return "fa fa-heartbeat"
      }
      return "fa fa-gear"
    },
    openDevice(dev) {

    },
    formatDate(date) {
      return (new Date(date*1000)).toLocaleString()
    },
    filterData() {
      this.updateMap()
      this.loadUtilization()
    },
    loadUtilization() {
      var that = this
      this.device = this.$router.history.current.fullPath.substring(8,this.$router.history.current.fullPath.length)
      var filter = {}
      if(this.dateFrom !== null && this.dateFrom != '') filter.dateFrom = Math.round(Date.parse(this.dateFrom)/1000)
      if(this.dateTo !== null && this.dateTo != '') filter.dateTo = Math.round(Date.parse(this.dateTo)/1000)
      telemetry.dailyDeviceActivity(this.device, filter).then(response => {
        this.utilizationcollection.datasets[0].data = []
        if(response.data !== undefined && this.utilizationcollection !== undefined) {
          Object.keys(response.data).forEach(function(key) {
            that.utilizationcollection.datasets[0].data.push({t: key*1000, y: (response.data[key].duration / 60 / 60)})
          })
        }
        if(this.showUtilization) this.$refs.utilChart.renderChart(this.utilizationcollection, this.utilChartOptions)
      })
    },
    updateMap() {
      this.$refs.mapa.$mapPromise.then(() => {
        var fullPath = this.$router.history.current.fullPath
        if(fullPath.startsWith("/assets/")) {
          this.view = "asset"
            this.device = this.$router.history.current.fullPath.substring(8,this.$router.history.current.fullPath.length)
            var filter = {hideLowAccuracy: this.hideLowAcc}
            //if(this.$refs.dateFrom!==undefined) console.log(this.$refs.dateFrom.$options)
            if(this.dateFrom !== null && this.dateFrom != '') filter.dateFrom = Math.round(Date.parse(this.dateFrom)/1000)
            if(this.dateTo !== null && this.dateTo != '') filter.dateTo = Math.round(Date.parse(this.dateTo)/1000)
            telemetry.devicePositions(this.device, filter).then(response => {
              if(response.data !== undefined && response.data.length > 0) {
                this.markers = [] //response.data
                var path = []
                var messages = []
                var bounds = new google.maps.LatLngBounds();
                //this.temperaturecollection.labels = []
                this.temperaturecollection.datasets[0].data = []
                this.batterycollection.datasets[0].data = []

                var minDate = 0
                var maxDate = 0

                if(response.data.length > 0) {
                    minDate = response.data[0].time
                    maxDate = response.data[0].time
                }

                for(var idx=0; idx < response.data.length; idx++) {
                  minDate = Math.min(response.data[idx].time, minDate)
                  maxDate = Math.max(response.data[idx].time, maxDate)
                  if(response.data[idx].position !== undefined && response.data[idx].position.lat !== undefined && response.data[idx].position.lat !== null) {
                    if(this.markers.length == 0) this.markers = [ response.data[idx] ]
                    path.push({lat: response.data[idx].position.lat, lng: response.data[idx].position.lng, time: response.data[idx].time, seqnumber: response.data[idx].seqnumber, event: response.data[idx].event, radius: response.data[idx].radius, source: response.data[idx].source, zones: response.data[idx].zones, _toggled: false, mac1: response.data[idx].mac1, mac2: response.data[idx].mac2, mac3: response.data[idx].mac3, temperature: response.data[idx].temperature, voltage: response.data[idx].voltage})
                    bounds.extend({lat: response.data[idx].position.lat, lng: response.data[idx].position.lng})
                  }
                  messages.push({lat: response.data[idx].position.lat, lng: response.data[idx].position.lng, time: response.data[idx].time, seqnumber: response.data[idx].seqnumber, event: response.data[idx].event, radius: response.data[idx].radius, source: response.data[idx].source, zones: response.data[idx].zones, _toggled: false, mac1: response.data[idx].mac1, mac2: response.data[idx].mac2, mac3: response.data[idx].mac3, temperature: response.data[idx].temperature, voltage: response.data[idx].voltage, lqi: response.data[idx].lqi})

                  //this.temperaturecollection.labels.push((new Date(response.data[idx].time*1000)).toLocaleString())
                  if(response.data[idx].temperature !== null && response.data[idx].temperature !== 0) this.temperaturecollection.datasets[0].data.push({t: response.data[idx].time*1000, y: response.data[idx].temperature})
                  if(response.data[idx].voltage !== null) this.batterycollection.datasets[0].data.push({t: response.data[idx].time*1000, y: response.data[idx].voltage})
                }
                /*
                for(var day = 0; day < (maxDate - minDate) / 86400; day++) {
                    this.temperaturecollection.labels.push((new Date(minDate*day*1000)).toLocaleString())
                }
                */
                //console.log(this.temperaturecollection.datasets[0].data)
                if(this.temperaturecollection.datasets[0].data.length > 0 && this.$refs.tempChart !== undefined) this.$refs.tempChart.renderChart(this.temperaturecollection, this.tempChartOptions)
                console.log(this.batterycollection, this.batterycollection.datasets[0].data.length)
                if(this.batterycollection.datasets[0].data.length > 0 && this.$refs.battChart !== undefined) this.$refs.battChart.renderChart(this.batterycollection, this.tempChartOptions)
                this.sliderOptions.max = path.length - 1
                this.currentMarker = path.length - 1
                this.paths = path
                this.messagesLoaded = messages
                this.pathsLoaded = path
                this.$refs.mapa.$mapObject.fitBounds(bounds)
              }
            }).catch((error) => {
              this.$toasted.error(error)
            })
        }
      })
    }
  }
}
</script>
